import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "BlockDetector" */ './lazyIndex')
);

export let detectBlockerLazy = new LazyAction(lazyModule, m => m.detectBlocker);
